import * as React from 'react'

import { Text, TextName } from 'sdk'
import { PopupId, SoundscapeDemoPopupContent } from 'redux/popupReducer'
import { SolutionsGridCard } from 'components/solutions-grid-card/SolutionsGridCard'

import classes from './style.module.scss'

export interface SolutionItem {
  logo: string
  bg: string
  description: string
  popupId?: PopupId
  popupContent?: SoundscapeDemoPopupContent
}

interface SolutionsGridProps {
  title: string
  solutions: SolutionItem[]
  onSolutionClick: (solution: SolutionItem) => void
}

export const SolutionsGrid: React.FC<SolutionsGridProps> = ({ title, solutions, onSolutionClick }) => {
  return (
    <div className={classes.wrapper}>
      <Text type={TextName.H2} className={classes.title}>
        {title}
      </Text>

      <div className={classes.solutions}>
        {solutions.map((solution, index) => (
          <SolutionsGridCard
            key={index}
            logo={solution.logo}
            bg={solution.bg}
            description={solution.description}
            onClick={() => onSolutionClick(solution)}
            className={classes.card}
          />
        ))}
      </div>
    </div>
  )
}
